import Button from '@ixigo/iui/Button';
import { FC } from 'react';
import { useConversation } from '../../contexts/conversation';
import { getFileType } from '../../utils/conversation';
import Uploader from '../Uploader';
import { UploadedFile } from '../Uploader/index.types';
import { InputFileConfig } from './index.types';

const FileInput: FC = () => {
    const { input, sendMessage } = useConversation();
    const config = input!.config as InputFileConfig;

    const onUpload = (file: File, data: UploadedFile) => {
        const fileData = {
            name: file.name,
            size: file.size,
            type: getFileType(file.type),
            url: data.secure_url,
        };

        const messageParts = [
            {
                isPrivate: false,
                file: fileData,
            },
        ];

        sendMessage({ messageParts, input: fileData });
    };

    return (
        <div className='flex gap-10 mr-40 ml-20'>
            <Button className='!px-20 !py-[8px]' variant='outlined'>
                <Uploader label={config.label || 'Upload'} onUpload={onUpload} />
            </Button>
        </div>
    );
};

export default FileInput;
